import { useMediaQuery, useTheme } from "@mui/material";

/**
 * True when viewport is below the canonical mobile boundary (theme md = 960px).
 */
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}

/**
 * True for compact phone widths (theme sm = 600px).
 */
export function useIsCompactPhone() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}
